module.exports = "static/img/bluecoders.8201d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bluecoders.png
// module id = 35
// module chunks = 1